import React from "react";
import { Box } from "@mui/material";
import NavigationBar from "../components/NavigationBar";

type WithNavigationBarProps = {
  children: React.ReactNode;
  callToAction?: React.JSX.Element;
};

const WithNavigationBar: React.FC<WithNavigationBarProps> = ({
  children,
  callToAction,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        bgcolor: "background.default",
      }}
    >
      <NavigationBar callToAction={callToAction} />
      {children}
    </Box>
  );
};

export default WithNavigationBar;
